/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { User } from '@kv-common-components/kx-services';

@Injectable({
    providedIn: 'root',
})
export class TagCommanderMapperService {
    public eadeUrlForTagCommander = {
        connexion: 'login',
        'tableau-de-bord': 'dashboard',
        'identifiant-oublie': 'resetusername',
        activation: 'accountactivation',
        'bsc/:primaryProvider/:secondaryProvider/:tokenBasculeMobile': '',
        reinitialisation: '',
        consentements: '',
        'questionnaire-de-sante-simplifie': 'qss',
        'questionnaire-de-sante': 'qs',
        signature: '',
        chargement: '',
        'document-selection-type': '',
        finalisation: '',
        'differed-decision-introduction': '',
        'document-list': '',
        recap: '',
        'next-step-introduction': '',
        'appointment-consent': '',
        'appointment-type': '',
        'appointment-details': '',
        'appointment-planner': '',
    };

    mapUtilisateur(currentUser: User, client: any) {
        return {
            utilisateur_assurance_ade: '',
            utilisateur_categorie: '',
            utilisateur_csp_fine: '',
            utilisateur_date_nais: client.dateNaissance,
            utilisateur_email: client.email,
            utilisateur_id_cr: currentUser.idApporteurPrincipal,
            utilisateur_id_agence: currentUser.idApporteurSecondaire,
            utilisateur_id_aia: client.idAia,
            utilisateur_id_client: client.idPersonne,
            utilisateur_id_conseiller: '',
            utilisateur_id_courtier: '',
            utilisateur_id_dir_regionale: '',
            utilisateur_id_externe: '',
            utilisateur_id_grp_agences: '',
            utilisateur_id_prospect: '',
            utilisateur_macro_csp: client.categorieSocioProfessionnelle,
            utilisateur_marche: '',
            utilisateur_segment: '',
            utilisateur_sexe: client.codeCivilite,
            utilisateur_situation_maritale: '',
            utilisateur_telephone: client.telephone,
        };
    }

    mapGlobalData(currentUser: User, globalData: any) {
        return {
            environnement_nom_du_site: globalData.nom_du_site,
            environnement_technique_du_site: globalData.technique_du_site,
            projet_dossier_id: currentUser.idDossier,
            id_cr: currentUser.idApporteurPrincipal,
        };
    }

    mapProjet(currentUser: User, espaceclient: any) {
        const contextDossier =
            ContextDossier.initContextDossierFromEspaceClient(
                currentUser.idPersonne,
                currentUser.idDossier.toString(),
                espaceclient
            );
        return {
            projet_dossier_id: currentUser.idDossier,
            projet_type: '',
            projet_prets: this.mapProjetPrets(contextDossier),
            projet_garantie: contextDossier.emprunteur
                ? this.mapProjetGaranties(contextDossier.emprunteur)
                : [],
            projet_emprunteur: this.mapProjetEmprunteur(contextDossier),
            projets: this.mapProjets(contextDossier),
        };
    }
    mapProjets(contextDossier: ContextDossier) {
        return [
            {
                projet_id: contextDossier.dossier.idProjetCredit,
                projet_type: '',
                projet_organisme_pret: '',
                projet_nb_pret: contextDossier.dossier.listePrets.length,
                projet_nb_emprunteurs: contextDossier.dossier.nombreEmprunteurs,
                projet_type_residence: '',
                utilisateur_marche: contextDossier.dossier.natureDossier,
                projet_prets: this.mapProjetPrets(contextDossier),
                projet_emprunteur: this.mapProjetEmprunteur(contextDossier),
            },
        ];
    }
    mapProjetPrets(contextDossier: ContextDossier) {
        return contextDossier.listPret.map((pret) => ({
            projet_pret_id: pret.idPret,
            projet_pret_typePret: pret.typePret,
            projet_pret_montant: pret.montant,
            projet_pret_duree: pret.duree,
        }));
    }
    mapProjetGaranties(emprunteur: any) {
        return emprunteur.assurance?.offreSelectionnee.listeGaranties.map(
            (garantie) => ({
                projet_garantie_quotite: garantie.id,
            })
        );
    }
    mapProjetEmprunteur(contextDossier: ContextDossier) {
        return contextDossier.dossier.listeEmprunteurs.map((emprunteur) => ({
            projet_emprunteur_id: emprunteur.idEmprunteur,
            projet_code_da_aia: emprunteur.statutDA,
            projet_code_produit: emprunteur.assurance
                ? emprunteur.assurance.offreSelectionnee
                : '',
            projet_montant_prime: emprunteur.assurance
                ? emprunteur.assurance.tarif.tarif.cotisationMensuelle
                : '',
            amount: emprunteur.assurance
                ? emprunteur.assurance.tarif.tarif.coutTotal
                : '',
            projet_proposition_id: emprunteur.idPropositionPrincipale,
            projet_kilometre: emprunteur.km,
            projet_fumeur: emprunteur.fumeur,
            projet_quotite: emprunteur.quotite,
            projet_garantie: emprunteur.assurance
                ? this.mapProjetGaranties(emprunteur)
                : [],
        }));
    }
}
